var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgCuratorLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 659 149.4",
    style: {
      enableBackground: "new 0 0 659 149.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#8C46FF;} ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.1,81.7L90.5,60V16.5c0-1.8-1-3.5-2.5-4.4c-3.3-1.9-7.5,0.5-7.5,4.4v49.3l42.7,24.6 c3.3,1.9,7.5-0.5,7.5-4.4C130.6,84.3,129.6,82.6,128.1,81.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.1,58.5l-17.6-10.1V28.1c0-1.8-1-3.5-2.5-4.4c-3.3-1.9-7.5,0.5-7.5,4.4v26.1l22.6,13 c3.4,1.9,7.5-0.5,7.5-4.4C130.6,61.1,129.6,59.4,128.1,58.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.1,35.3L128.1,35.3c-1.6-0.9-3.5-0.9-5,0c-1.6,0.9-2.5,2.6-2.5,4.4s1,3.5,2.5,4.4c1.6,0.9,3.5,0.9,5,0 c1.6-0.9,2.5-2.6,2.5-4.4S129.7,36.2,128.1,35.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.6,90.4l42.7-24.6V16.5c0-3.9-4.2-6.3-7.5-4.4c-1.6,0.9-2.5,2.6-2.5,4.4V60L2.7,81.7 c-1.6,0.9-2.5,2.6-2.5,4.4C0,89.9,4.2,92.3,7.6,90.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.6,58.5c-1.6,0.9-2.5,2.6-2.5,4.4c0,3.9,4.2,6.3,7.5,4.4l22.6-13V28.1c0-3.9-4.2-6.3-7.5-4.4 c-1.6,0.9-2.5,2.6-2.5,4.4v20.3L2.6,58.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.5,44L2.5,44c1.6,0.9,3.5,0.9,5,0c1.6-0.9,2.5-2.6,2.5-4.4s-1-3.5-2.5-4.4c-1.6-0.9-3.5-0.9-5,0 C0.9,36.1,0,37.8,0,39.6S1,43.1,2.5,44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108,116.5L65.3,91.9l-42.7,24.6c-3.4,1.9-3.4,6.8,0,8.7c1.6,0.9,3.5,0.9,5,0l37.6-21.7l37.6,21.7 c1.6,0.9,3.5,0.9,5,0C111.3,123.3,111.3,118.5,108,116.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.9,128.1l-22.6-13l-22.6,13c-3.3,1.9-3.3,6.8,0,8.7c1.6,0.9,3.5,0.9,5,0l17.6-10.1l17.6,10.1 c1.6,0.9,3.5,0.9,5,0C91.2,134.9,91.2,130.1,87.9,128.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.8,139.7c-1.6-0.9-3.5-0.9-5,0c-1.6,0.9-2.5,2.6-2.5,4.4s1,3.5,2.5,4.4c1.6,0.9,3.5,0.9,5,0 c1.6-0.9,2.5-2.6,2.5-4.4S69.4,140.6,67.8,139.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.3,83.2L50.3,83.2c-1.4-2.4-4.5-3.2-6.9-1.8L2.6,105c-2.4,1.4-3.2,4.5-1.8,6.9c1.4,2.4,4.5,3.2,6.9,1.8 l40.8-23.6C50.8,88.6,51.6,85.6,50.3,83.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.1,104.9L87.3,81.3c-2.4-1.4-5.5-0.6-6.9,1.8c-1.4,2.4-0.6,5.5,1.8,6.9l40.8,23.6 c2.4,1.4,5.5,0.6,6.9-1.8C131.3,109.4,130.5,106.3,128.1,104.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.3,57.1c2.8,0,5-2.2,5-5V5c0-2.8-2.3-5-5-5c-2.8,0-5,2.3-5,5v47.1C60.3,54.8,62.5,57.1,65.3,57.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.8,70.1L67.8,70.1c-1.6-0.9-3.5-0.9-5,0c-1.6,0.9-2.5,2.6-2.5,4.4s1,3.5,2.5,4.4c1.6,0.9,3.5,0.9,5,0 c1.6-0.9,2.5-2.6,2.5-4.4S69.4,71,67.8,70.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M319,35.6v47c0,11.2-4,20.8-19.8,20.8s-19.8-9.6-19.8-20.8v-47h-12.1v47.8c0,20.3,11,31.2,31.9,31.2 c20.8,0,31.9-10.9,31.9-31.2V35.6H319z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M345.9,63.5v49.9H358v-49c0-13,3.7-18,14.1-18h17.8V35.6h-17.8C355.2,35.6,345.9,44.7,345.9,63.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.9,45.3c11.8,0,21.1,5,22.8,15h12.5c-2.2-15.7-15.3-26-34.9-26c-20.1,0-37.7,13.6-37.7,40.2 s17.6,40.2,37.7,40.2c19.6,0,32.7-10.4,34.9-26.1h-12.5c-1.8,9.9-11.1,15-22.8,15c-13.2,0-24.5-8.8-24.5-29.1 S203.7,45.3,216.9,45.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M641.5,35.6c-17,0-26.2,9.1-26.2,27.9v49.9h12.1v-49c0-13,3.7-18,14.1-18h17.8V35.6H641.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M564.1,103.6c-13.2,0-26.8-8.8-26.8-29.1c0-20.4,13.6-29.1,26.8-29.1s26.8,8.8,26.8,29.1 C590.9,94.9,577.4,103.6,564.1,103.6 M564.1,34.3c-20.1,0-39.5,13.6-39.5,40.2s19.4,40.2,39.5,40.2s39.5-13.6,39.5-40.2 S584.2,34.3,564.1,34.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M487.4,11.1h-12.1v72.2c0,20.3,6.3,30.1,27.1,30.1h17v-10.8h-16.5c-12.8,0-15.6-6.2-15.6-20.8V46.4h32.1V35.6 h-32.1L487.4,11.1L487.4,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M427.6,104.1c-13.8,0-20.2-5.9-20.2-14.6c0-8.7,5.8-13.4,15.8-13.4h25.1v12.5 C448.3,98.5,441,104.1,427.6,104.1 M428.5,34.3c-18.2,0-30.9,9.1-33,26h12c1.3-8.4,7.9-15.8,20.9-15.8c15.7,0,19.7,10,19.8,21.1 h-26.8c-17,0-27,11.6-27,23.9c0,13.8,11.1,25.2,33.3,25.2s32.6-10.4,32.6-26.6V65.5C460.4,45.1,449.4,34.3,428.5,34.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M639.4,104.7h-3.1v-2.1h8.7v2.1h-3.1v8.7h-2.4v-8.7H639.4z M647.5,102.6h2.8l3.1,7.5l3.1-7.5h2.7v10.8H657 v-6.6l-2.8,6.6h-1.6l-2.8-6.6v6.6h-2.3V102.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuratorLogo);
export default __webpack_public_path__ + "static/media/Curator_Logo.e8702d17dc615a032a416b9649e67b58.svg";
export { ForwardRef as ReactComponent };